import { SkeletonButton } from '@/components/Skeleton';
import MobileHistoryCard from './index';

const MobileHistorySkeleton = () => {
  return (
    <>
      {[1, 2, 3].map((key) => (
        <MobileHistoryCard
          key={key}
          header={
            <>
              <div className="value">
                <SkeletonButton width={100} height={16} />
              </div>
              <div className="value">
                <SkeletonButton width={60} height={16} />
              </div>
            </>
          }>
          <div className="syn-mobile-history-card-row">
            <div className="label">
              <SkeletonButton width={80} height={14} />
            </div>
            <div className="value">
              <SkeletonButton width={100} height={14} />
            </div>
          </div>
          <div className="syn-mobile-history-card-row">
            <div className="label">
              <SkeletonButton width={80} height={14} />
            </div>
            <div className="value">
              <SkeletonButton width={100} height={14} />
            </div>
          </div>
          <div className="syn-mobile-history-card-row">
            <div className="label">
              <SkeletonButton width={80} height={14} />
            </div>
            <div className="value">
              <SkeletonButton width={100} height={14} />
            </div>
          </div>
        </MobileHistoryCard>
      ))}
    </>
  );
};

export default MobileHistorySkeleton;
